import { PRODUCTION_HOSTNAME } from 'features/common/app/constants';

export function mapToQueryString(json) {
	const query = [];
	for (const key of Object.keys(json)) {
		const value = json[key];
		if (value !== undefined && value != null && value !== '') {
			if (Array.isArray(value)) {
				value.forEach((param) => {
					query.push(`${encodeURIComponent(key)}=${encodeURIComponent(param)}`);
				});
			} else {
				query.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
			}
		}
	}
	return query.join('&');
}

/**
 * Get the URL query parameter if exists
 *
 * @param {any} name
 * @param {any} [url=window.location.href]
 * @returns
 * @see https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
 */
export function getParameterByName(name, url = window.location.href) {
	name = name.replace(/[\[\]]/g, '\\$&');
	const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
	const results = regex.exec(url);
	if (!results) {
		return null;
	}
	if (!results[2]) {
		return '';
	}
	return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

/**
 * Get whether application runs on production or not
 *
 * @returns {boolean}
 */
export const isProductionEnvironment = () => {
	return window.location.host === PRODUCTION_HOSTNAME;
};
